<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}"
               v-if="path.hideTitle === undefined || !path.hideTitle">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>

        <v-text-field readonly
                      style="padding-top: 0 !important;"
                      :value="fieldValue"
                      @click="showPicker = true"
                      outlined
                      hide-details
                      :class="{'input-error': submitted && fieldValue === null}">
        </v-text-field>

        <v-dialog ref="dialog" v-model="showPicker" width="290px">
            <v-date-picker locale="fr-FR" color="primary"
                           v-model="selectedDate"
                           @input="updateFieldValue($event)"
                           :first-day-of-week="1">
                <v-spacer></v-spacer>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import HelpTooltip from "../../../tools/HelpTooltip.vue"

import {mapGetters, mapMutations, mapState} from "vuex"
import {fieldsMapping} from "../../../../static/webform"

export default {
    name: "FormDate",
    props: ['field'],
    components: {HelpTooltip},
    data() {
        return {
            showPicker: false,
            selectedDate: null
        }
    },
    methods: {
        ...mapMutations('web_form', ['updateProviderFieldValue']),
        updateFieldValue(value) {
            this.updateProviderFieldValue([this.path, value])
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", "primaryColor"]),
        ...mapState("web_form", ['submitted', 'provider']),
        ...mapGetters('web_form', ['getCodeFromField', 'getProviderFieldValue']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            let value = this.getProviderFieldValue(this.path)

            return typeof value === 'string' ? this.formatDate(value, false) : null
        },
        placeholder() {
            return this.path.placeholder !== undefined ? this.path.placeholder : null
        }
    }
}
</script>